module.exports = __webpack_public_path__ + "static/media/appledownload.6d2d3453.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/appledownload.png
// module id = 297
// module chunks = 0